/* eslint-disable default-case */

import 'messenger-hubspot/build/js/messenger';

export default {

  methods: {

    registerCommunicatorBusEvents() {
      Bus.$on('reload', () => {
        window.location.reload();
      });

      Bus.$on('broadcast', (event) => {
        // console.log('communicator.created.broadcast', event);

        switch (event.message) {
          case 'reload':
            Bus.$emit('reload');
            break;

          case 'logout':
            this.$auth.logout();
            this.$router.push('/');
            break;

          default:
            Messenger().post({
              message: event.message,
              hideAfter: 3,
              hideOnNavigate: true,
            });
        }
      });

      Bus.$on('livelog', (event) => {
        // console.log('communicator.created.livelog', event);

        Messenger().post({
          type: event.data.type,
          message: `${event.data.module} - ${event.data.channel} - ${event.data.message}`,
          hideAfter: 10,
          hideOnNavigate: true,
        });
      });

      Bus.$on('notify', (event) => {
        const actionText = event.type;

        console.log('communicator.created.notify.user', this.$auth.user());

        // Only show events to super admin
        if (this.$auth.user().id === 1) {
          this.$notify({
            group: 'transient-notifications',
            type: 'success',
            title: actionText,
            // text: actionText
          });
        }

        console.log('communicator.created.notify.event', event);

        switch (event.type) {
          default:
            console.log('communicator.created.notify.event.default', event);
            break;
        }
      });
    },

    joinCommunicatorChannels() {
      // console.log(`joinCommunicatorChannels.private.notifications.${this.$auth.user().id}`);

      window.Echo.private(`notifications.${this.$auth.user().id}`)
        .listen('.MessageBroadcast', (e) => {
          // console.log('echo.MessageBroadcast', e);

          Bus.$emit('broadcast', e);
        })
        .listen('.AdminBroadcast', (e) => {
          console.log('echo.AdminBroadcast', e.type);

          switch (e.type) {
            case 'refresh':
              Bus.$emit('refresh', 'all');
              break;

            case 'global-count':
              this.$store.dispatch('updateFetcherGlobalCount', e.data);
              // console.log(e);
              if (e.data.jobType === 'fetch-details-post') {
                Bus.$emit('refresh', 'featuredVideos');
              }
              break;

            case 'global-counts':
              this.$store.dispatch('updateFetcherGlobalCounts', e.data);
              break;
          }
        })
        .listen('.LiveLogBroadcast', (e) => {
          // console.log('echo.MessageBroadcast', e);

          if (e.type === 'livelog') {
            // console.log('livelog', e);
            if (e.data.type === 'clear') {
              this.$store.dispatch('clearLog', e.data);
            } else {
              this.$store.dispatch('appendToLog', e.data);
            }
          }

          if (e.data.channel === 'queueLog') {
            Bus.$emit('livelog', e);
          }
        });
    },

    leaveCommunicatorChannels() {
      // window.Echo.leave(`App.User.${this.$auth.user().id}`);
      window.Echo.leave(`notifications.${this.$auth.user().id}`);
    },
  },

  created() {
    Messenger.options = {
      extraClasses: 'messenger-fixed messenger-on-top messenger-on-right',
      theme: 'future',
    };
  },

  mounted() {
    // console.log('auth.check', this.$auth.check());
    // console.log('auth.user', this.$auth.user());
    this.joinCommunicatorChannels();

    this.registerCommunicatorBusEvents();
  },

  beforeDestroy() {
    this.leaveCommunicatorChannels();
    Bus.$off('broadcast');
    Bus.$off('livelog');
    Bus.$off('notify');
  },

};
